/**
 * סוגי מסלולי השקעה בתיק השקעות
 * תואם ל-backend/DTO/manual_product_type.py InvestmentPathType
 */
export enum InvestmentPathType {
  ISRAEL_STOCKS = 1, // מניות ישראל
  FOREIGN_STOCKS = 2, // מניות חו"ל
  CORPORATE_INDEXED_BONDS = 3, // אג"ח קונצרני צמוד
  GOVT_INDEXED_BONDS = 4, // אג"ח ממשלתי צמוד
  GOVT_SHEKEL_BONDS = 5, // אג"ח ממשלתי שקלי
  CORPORATE_SHEKEL_BONDS = 6, // אג"ח קונצרני שקלי
  FOREIGN_BONDS = 7, // אג"ח חו"ל
  FOREIGN_CURRENCY = 8, // מט"ח
  CASH = 9, // מזומנים
  STRUCTURED_PRODUCTS = 10, // מוצרים מובנים
}
